import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/order-info.module.scss';
import InfoItem from 'src/components/InfoItem';
import { IOrder } from 'src/types/order';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { IStudent } from '../../../../../../types/student';
import { QueryParams } from '../../../../../../types/grid';
import OrderEnum from '../../../../../../enumerables/order-enum';
import { getValFromEnum } from '../../../../../../components/redux-form/utils/dropdown-values';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import RenderFile from '../../../../../../components/RenderFile';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../helpers/format';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import CreateOrderButton from '../OrderList/components/CreateOrderButton';

export interface StateProps {
    files: any;
    order: Partial<IOrder> | null;
    students: Paginated<IStudent>;
}

export interface DispatchProps {
    getStudentsAct: (params: QueryParams) => void;
    getFiles: (id: string | number) => void;
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const OrderInfo: React.FunctionComponent<Props> = ({
    order,
    getData,
    getFiles,
    files,
    getStudentsAct,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getFiles(id);
            getData(id);
            getStudentsAct({
                page: 1,
                itemsPerPage: 9000,
            });
        }
    }, [getData, getFiles, id, getStudentsAct]);

    if (!order) {
        return null;
    }
    const {
        name,
        caseNumberValidityFrom,
        caseNumberValidityTo,
        authorizationDate,
        allocatedHours,
        allocatedMoney,
        note,
        orderDoc,
        orderDocName,
        orderDocMimeType,
        maximumAvailableHours,
    } = order;

    const typeEnumSubT = OrderEnum ? OrderEnum.getEnum('OrderSubtype') : {};
    const valuesOrderSubtype: SelectObject[] = getValFromEnum(typeEnumSubT);

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const AuthorizationSources = OrderEnum ? OrderEnum.getEnum('AuthorizationSource') : {};
    const valuesAuthorizationSources: SelectObject[] = getValFromEnum(AuthorizationSources);

    const AllocatedPeriod = OrderEnum ? OrderEnum.getEnum('AllocatedPeriod') : {};
    const valuesAllocatedPeriod: SelectObject[] = getValFromEnum(AllocatedPeriod);

    const OrderStatusValues = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
    const valuesOrderStatus: SelectObject[] = getValFromEnum(OrderStatusValues);

    const ServiceTypeProviders = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const valuesServiceTypeProvider: SelectObject[] = getValFromEnum(ServiceTypeProviders);

    const OrderReferralSourceValues = OrderEnum ? OrderEnum.getEnum('ReferralSource') : {};
    const valuesOrderReferralSource: SelectObject[] = getValFromEnum(OrderReferralSourceValues);

    const valueAuthorizationSources = valuesAuthorizationSources.find((it) => it.value === order.authorizationSource);
    const orderSubtype = valuesOrderSubtype.find((it) => it.value === order.orderSubtype);
    const allocatedPeriod = valuesAllocatedPeriod.find((it) =>
        +it.value === order.allocatedPeriod ? +order.allocatedPeriod : 0,
    );
    const valueStatus = valuesOrderStatus.find((it) => it.value === order.status);
    const valueServiceTypeProvider = valuesServiceTypeProvider.find((it) => it.value === order.serviceTypeProvider);
    const valueOrderType = orderTypes.find((it) => it.value === order.orderType);
    const serviceTypeValue = order.serviceType ? order.serviceType.title : '';
    const studName = order.student ? `${order.student.firstName} ${order.student.lastName}` : null;
    const caseNumberValidityFromVal = caseNumberValidityFrom
        ? changeToZeroMoment(caseNumberValidityFrom, 'MMM D, YYYY')
        : null;
    const caseNumberValidityToValue = caseNumberValidityTo
        ? changeToZeroMoment(caseNumberValidityTo, 'MMM D, YYYY')
        : null;
    const authorizationDateValue = authorizationDate ? changeToZeroMoment(authorizationDate, 'MMM D, YYYY') : null;
    const authorizationDateRequestValue = order.authorizationDateRequest
        ? changeToZeroMoment(order.authorizationDateRequest, 'MMM D, YYYY')
        : null;
    const orderDateValue = order.orderDate ? changeToZeroMoment(order.orderDate, 'MMM D, YYYY') : null;
    const orderExpiration = order.orderExpiration ? changeToZeroMoment(order.orderExpiration, 'MMM D, YYYY') : null;
    const createdAtValue = order.createdAt ? changeToZeroMoment(order.createdAt, 'MMM D, YYYY') : null;
    const previewFiles = (data: any) =>
        data &&
        data.map((file: any, i: number) => (
            <li style={{ listStyleType: 'none' }} key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    <RenderFile file={file} />
                </a>
            </li>
        ));
    const previewFilesData =
        files &&
        files.map((file: any, i: number) => (
            <li key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    <RenderFile file={file} />
                </a>
            </li>
        ));
    const orderDocFiles = [];
    if (orderDoc) {
        const orderDocFile = {
            attach: orderDoc,
            mimeType: orderDocMimeType,
            name: orderDocName,
        };
        orderDocFiles.push(orderDocFile);
    }
    //allocatedHours(pin):12.3
    //allocatedMoney(pin):null

    return (
        <RoleLayout>
            <Breadcrumbs
                noGenerate={true}
                items={[
                    { name: 'ORDERS', path: Router.generate(routes.ORDERS_LIST, { status: '' }) },
                    { name: `${name}`, path: '' },
                ]}
            />
            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}>
                    <InfoItem title={'#:'} value={id} />
                    <InfoItem title={'Status:'} value={valueStatus?.label} />
                    <InfoItem title={'Name:'} value={name} />
                    <InfoItem title={'Case Number:'} value={order.caseNumber} />
                    <InfoItem title={'Order Type:'} value={valueOrderType?.label} />
                    <InfoItem title={'Allocated Period:'} value={allocatedPeriod?.label} />
                    <InfoItem title={'Allocated Hours:'} value={allocatedHours && `${allocatedHours} hrs`} />
                    <InfoItem
                        title={'Maximum Available Hours:'}
                        value={maximumAvailableHours && `${maximumAvailableHours} hrs`}
                    />
                    <InfoItem
                        title={'Allocated Money:'}
                        value={allocatedMoney ? `$${numberWithCommas(allocatedMoney)}` : '$0.00'}
                    />
                    <InfoItem title={'Full Name Student:'} value={studName} />
                    <InfoItem title={'Service Type Provider:'} value={valueServiceTypeProvider?.label} />
                    <InfoItem title={'Service Type:'} value={serviceTypeValue} />
                    <InfoItem title={'Case Number Validity From:'} value={caseNumberValidityFromVal} />
                    <InfoItem title={'Case Number Validity To'} value={caseNumberValidityToValue} />
                    <InfoItem title={'Order Subtype:'} value={orderSubtype?.label} />
                    <InfoItem title={'Order Date:'} value={orderDateValue} />
                    <InfoItem title={'Order Expiration:'} value={orderExpiration} />
                    <InfoItem title={'Date Authorization Was Requested:'} value={authorizationDateRequestValue} />
                    <InfoItem title={'Authorization Date:'} value={authorizationDateValue} />
                    <InfoItem title={'Authorization Source:'} value={valueAuthorizationSources?.label} />
                    <InfoItem title={'Note:'} value={note} />
                    <InfoItem title={'Created:'} value={createdAtValue} />
                    <InfoItem title={'The Order:'} value={previewFiles(orderDocFiles)} />
                    <InfoItem title={'Documents:'} value={previewFilesData} />
                </div>

                <div>
                    {user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                        <Link
                            className={classNames('btn', 'btn-outline-secondary')}
                            to={Router.generate(routes.ORDER_EDIT, { id })}
                        >
                            EDIT
                        </Link>
                    ) : (
                        <div></div>
                    )}
                </div>
            </div>
        </RoleLayout>
    );
};

export default OrderInfo;
